/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { VestaEIR, VestaEIRInterface } from "../VestaEIR";

const _abi = [
  {
    inputs: [],
    name: "CannotBeZero",
    type: "error",
  },
  {
    inputs: [],
    name: "NoDebtFound",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInterestManager",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "x",
        type: "int256",
      },
    ],
    name: "PRBMathSD59x18__Exp2InputTooBig",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "x",
        type: "int256",
      },
    ],
    name: "PRBMathSD59x18__ExpInputTooBig",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
    ],
    name: "PRBMathUD60x18__Exp2InputTooBig",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
    ],
    name: "PRBMathUD60x18__LogInputTooSmall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "prod1",
        type: "uint256",
      },
    ],
    name: "PRBMath__MulDivFixedPointOverflow",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "debt",
        type: "uint256",
      },
    ],
    name: "DebtChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newEIR",
        type: "uint256",
      },
    ],
    name: "EIRChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256",
      },
    ],
    name: "Exit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "Flee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "interest",
        type: "uint256",
      },
    ],
    name: "InterestMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "val",
        type: "uint256",
      },
    ],
    name: "Join",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "risk",
        type: "uint8",
      },
    ],
    name: "RiskChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "debt",
        type: "uint256",
      },
    ],
    name: "SystemDebtChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "src",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "dst",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "wad",
        type: "uint256",
      },
    ],
    name: "Tack",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_eir",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_timeInYear",
        type: "uint256",
      },
    ],
    name: "compound",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "crops",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentEIR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentRisk",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dec",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
    ],
    name: "decreaseDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "addedInterest_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
    ],
    name: "exit",
    outputs: [
      {
        internalType: "uint256",
        name: "addedInterest_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "gem",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
    ],
    name: "getDebtOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_risk",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_price",
        type: "uint256",
      },
    ],
    name: "getEIR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNotEmittedInterestRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ilk",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_debt",
        type: "uint256",
      },
    ],
    name: "increaseDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "addedInterest_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "interestManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interestMinted",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastUpdate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "netAssetValuation",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "netAssetsPerShare",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "risk",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "safetyVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "_newRisk",
        type: "uint8",
      },
    ],
    name: "setRisk",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newSafetyVault",
        type: "address",
      },
    ],
    name: "setSafetyVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vst",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstOperator",
        type: "address",
      },
      {
        internalType: "address",
        name: "_safetyVault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_interestManager",
        type: "address",
      },
      {
        internalType: "string",
        name: "_moduleName",
        type: "string",
      },
      {
        internalType: "string",
        name: "_moduleSymbol",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "_defaultRisk",
        type: "uint8",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "share",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stake",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "total",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDebt",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_vstPrice",
        type: "uint256",
      },
    ],
    name: "updateEIR",
    outputs: [
      {
        internalType: "uint256",
        name: "mintedInterest_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vat",
    outputs: [
      {
        internalType: "contract IVatLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vst",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vstOperator",
    outputs: [
      {
        internalType: "contract IVSTOperator",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "0x6080604052621d02e560d55534801561001757600080fd5b50612f52806100276000396000f3fe608060405234801561001057600080fd5b50600436106102535760003560e01c8063a553762011610146578063de364b07116100c3578063f2fde38b11610087578063f2fde38b146104ec578063f3c85eba146104ff578063f547beb514610512578063f8585db31461051b578063fc7b9c181461052e578063ffde0f971461053757600080fd5b8063de364b0714610488578063e23911ff1461049b578063eac9015e146104ae578063ee065e11146104c6578063ee9e8199146104d957600080fd5b8063ba5cf3b41161010a578063ba5cf3b414610447578063bdf3c4ae1461045a578063c046371114610463578063c557d76d1461046c578063c5ce281e1461047f57600080fd5b8063a5537620146103ea578063a8d5fd6514610413578063aaf5eb681461041c578063b3bcfa821461042b578063b42652e91461043457600080fd5b8063426a0c88116101d457806380d231aa1161019857806380d231aa146103ab5780638217b8461461028d5780638261f533146103be5780638da5cb5b146103d157806395d89b41146103e257600080fd5b8063426a0c88146103375780636e7451381461035d57806370a0823114610365578063715018a61461038e5780637bd2bea71461039857600080fd5b80632ddbd13a1161021b5780632ddbd13a146102d55780632ebcda28146102de5780632fb9ba31146102f1578063313ce5671461030457806336569e771461030c57600080fd5b806306fdde031461025857806307a1e7ae1461027657806318160ddd1461028d57806326476204146102955780632baeda48146102b5575b600080fd5b610260610544565b60405161026d91906126bc565b60405180910390f35b61027f60d65481565b60405190815260200161026d565b606a5461027f565b61027f6102a3366004612721565b606d6020526000908152604090205481565b61027f6102c3366004612721565b606c6020526000908152604090205481565b61027f606a5481565b61027f6102ec36600461273c565b6105d2565b61027f6102ff366004612755565b610611565b61027f601281565b60655461031f906001600160a01b031681565b6040516001600160a01b03909116815260200161026d565b60db5461034b90600160a01b900460ff1681565b60405160ff909116815260200161026d565b61027f6107a2565b61027f610373366004612721565b6001600160a01b03166000908152606d602052604090205490565b6103966107d4565b005b60675461031f906001600160a01b031681565b60da5461031f906001600160a01b031681565b6103966103cc366004612721565b6107e8565b6033546001600160a01b031661031f565b610260610812565b61027f6103f8366004612721565b6001600160a01b0316600090815260dd602052604090205490565b61027f60695481565b61027f670de0b6b3a764000081565b61027f60685481565b61027f610442366004612721565b61081f565b61039661045536600461278e565b6108cc565b61027f606b5481565b61027f60d75481565b61027f61047a3660046127ab565b61099a565b61027f60665481565b61027f610496366004612721565b610a60565b6103966104a936600461286c565b610bfe565b60d95461031f9061010090046001600160a01b031681565b60dc5461031f906001600160a01b031681565b60db5461031f906001600160a01b031681565b6103966104fa366004612721565b610dd4565b61027f61050d366004612927565b610e4d565b61027f60705481565b61027f610529366004612755565b610e9e565b61027f60d85481565b60d95461034b9060ff1681565b60a2805461055190612953565b80601f016020809104026020016040519081016040528092919081815260200182805461057d90612953565b80156105ca5780601f1061059f576101008083540402835291602001916105ca565b820191906000526020600020905b8154815290600101906020018083116105ad57829003601f168201915b505050505081565b60dc546000906001600160a01b031633146106005760405163e1a54d8560e01b815260040160405180910390fd5b61060982610f6d565b90505b919050565b60dc546000906001600160a01b0316331461063f5760405163e1a54d8560e01b815260040160405180910390fd5b8160000361066057604051631e1d0ab560e01b815260040160405180910390fd5b61066983611105565b6001600160a01b038416600090815260dd60205260408120805492935090919084908361069683856129a3565b92505081905590506000606a541180156106b05750600081115b156106d35760d85481606a546106c691906129b6565b6106d091906129e3565b91505b6106fb856106f6876001600160a01b03166000908152606d602052604090205490565b6111ce565b610705858361121e565b8360d8600082825461071791906129a3565b9091555050604080516001600160a01b0387168152602081018390527f206b7154b31a11c2b2e6152606cd086dfceae80d3b4e43cefa0f0b39ea0e1c63910160405180910390a17f54b47acc73b0f2121474f0c9237b0f5a57882108724b01b9868b3045ce63403e60d85460405161079191815260200190565b60405180910390a150505b92915050565b6000606a546000036107bb5750670de0b6b3a764000090565b6107cf6107c7606a5490565b606a54611266565b905090565b6107dc611285565b6107e660006112df565b565b6107f0611285565b60db80546001600160a01b0319166001600160a01b0392909216919091179055565b60a3805461055190612953565b60dc546000906001600160a01b0316331461084d5760405163e1a54d8560e01b815260040160405180910390fd5b6001600160a01b038216600090815260dd6020526040812054900361088557604051633c74e66760e01b815260040160405180910390fd5b61088e82611105565b6001600160a01b038316600090815260dd6020526040812055905061060c826106f6816001600160a01b03166000908152606d602052604090205490565b6108d4611285565b60db805460ff60a01b1916600160a01b60ff84160217905560dc5460408051636ae7c5cf60e01b81529051610960926001600160a01b031691636ae7c5cf9160048083019260209291908290030181865afa158015610937573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061095b91906129f7565b610f6d565b5060405160ff821681527f018e90a59e921a225d25ed052750b34d7c5e327fb2e32f0ca4d127ae4e9264e49060200160405180910390a150565b6000670d2f13f7789f00008210156109bc57670d2f13f7789f000091506109d8565b670e92596fd62900008211156109d857670e92596fd629000091505b600060646109ee670de0b6b3a764000085612a10565b6109f89190612a37565b905060008460ff16600003610a105750611388610a29565b8460ff16600103610a245750611d4c610a29565b506130d45b6000610a388361289c19612a65565b9050610a5682610a4783611331565b68056bc75e2d631000006113a1565b9695505050505050565b6000606a54600003610a7457506000919050565b6000603c60d75442610a8691906129a3565b610a9091906129e3565b905060008115610ab457610ab160d65460d85460d5548561050d91906129b6565b90505b6000610acf82607054610ac79190612a95565b606b546113e1565b90506000610aea606954610ae584606a54611437565b611450565b604051630575db4960e31b81526001600160a01b03881660048201529091506000903090632baeda4890602401602060405180830381865afa158015610b34573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b5891906129f7565b604051630991d88160e21b81526001600160a01b0389166004820152909150600090610bd0903090632647620490602401602060405180830381865afa158015610ba6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bca91906129f7565b846114a5565b905081811115610bf057610be482826129a3565b98975050505050505050565b506000979650505050505050565b600054610100900460ff1615808015610c1e5750600054600160ff909116105b80610c385750303b158015610c38575060005460ff166001145b610ca05760405162461bcd60e51b815260206004820152602e60248201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160448201526d191e481a5b9a5d1a585b1a5e995960921b60648201526084015b60405180910390fd5b6000805460ff191660011790558015610cc3576000805461ff0019166101001790555b610ccd84846114be565b60d980546001600160a01b03808b1661010002610100600160a81b03199092169190911790915560da80548983166001600160a01b03199182161790915560db805460dc80548a861694168417905560ff8616600160a01b026001600160a81b0319909116938a1693909317929092179091554260d75560408051636ae7c5cf60e01b81529051610d839291636ae7c5cf9160048281019260209291908290030181865afa158015610937573d6000803e3d6000fd5b508015610dca576000805461ff0019169055604051600181527f7f26b83ff96e1f2b6a682f133852f6798a09c465da95921460cefb38474024989060200160405180910390a15b5050505050505050565b610ddc611285565b6001600160a01b038116610e415760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610c97565b610e4a816112df565b50565b600082610e8a81610e7c85610e638960646129b6565b610e6d91906129b6565b6725b94542080c80009061156a565b670de0b6b3a76400006115ac565b610e9491906129a3565b90505b9392505050565b60dc546000906001600160a01b03163314610ecc5760405163e1a54d8560e01b815260040160405180910390fd5b670de0b6b3a7640000610ede84611105565b915060008360dd6000876001600160a01b03166001600160a01b031681526020019081526020016000206000828254610f179190612a95565b92505081905590506000606a541115610f515760d854610f378486612a95565b606a54610f4491906129b6565b610f4e91906129e3565b91505b610f5b858361121e565b8360d860008282546107179190612a95565b600080610f8960db60149054906101000a900460ff168461099a565b60d65460d85460d7549293509091600090603c90610fa790426129a3565b610fb191906129e3565b60d68590556040518581529091507fdef563d050898b7d1669c8608895ce87133910200ea93fdbddadcd33a9be05999060200160405180910390a1806000036110005750600095945050505050565b4260d75560d85460d55461101a91859161050d90856129b6565b60d8600082825461102b9190612a95565b909155505060d8546000906110419084906129a3565b905080607060008282546110559190612a95565b909155505060da5460db546040516340c10f1960e01b81526001600160a01b039182166004820152602481018490529116906340c10f1990604401600060405180830381600087803b1580156110aa57600080fd5b505af11580156110be573d6000803e3d6000fd5b505050507fb5f52c26162e22d72313152194e9c1757820c6ac28a61603445aec8b3561f70f816040516110f391815260200190565b60405180910390a19695505050505050565b606a546000901561112d57611129606954610ae561112161165a565b606a54611437565b6069555b6001600160a01b0382166000908152606c6020908152604080832054606d90925282205460695491929161116191906114a5565b9050818111156111c15761117582826129a3565b6001600160a01b038516600090815260dd60205260408120805492955085929091906111a2908490612a95565b9250508190555082607060008282546111bb91906129a3565b90915550505b5050607054606b55919050565b6111d8828261166a565b6040518181526000906001600160a01b038416907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906020015b60405180910390a35050565b611228828261186c565b6040518181526001600160a01b038316906000907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef90602001611212565b60008161127b84670de0b6b3a7640000611a55565b610e9791906129e3565b6033546001600160a01b031633146107e65760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610c97565b603380546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600068023f2fa8f6da5b9d311982121561134d57506000919050565b680736ea4425c11ac6318212611379576040516399bb754160e01b815260048101839052602401610c97565b6714057b7ef767814f8202610e97670de0b6b3a76400006706f05b59d3b20000830105611abc565b60006113ae8484846115ac565b9050600082806113c0576113c06129cd565b8486091115610e975760001981106113d757600080fd5b6001019392505050565b6000826113ee83826129a3565b915081111561079c5760405162461bcd60e51b815260206004820152601560248201527464732d6d6174682d7375622d756e646572666c6f7760581b6044820152606401610c97565b60008161127b846b033b2e3c9fd0803ce8000000611a55565b60008261145d8382612a95565b915081101561079c5760405162461bcd60e51b815260206004820152601460248201527364732d6d6174682d6164642d6f766572666c6f7760601b6044820152606401610c97565b60006b033b2e3c9fd0803ce800000061127b8484611a55565b600054610100900460ff166114e55760405162461bcd60e51b8152600401610c9790612aa8565b61154c6040516114f4906126a3565b604051809103906000f080158015611510573d6000803e3d6000fd5b50682b22a9aa209722a4a960b91b60405161152a906126af565b604051809103906000f080158015611546573d6000803e3d6000fd5b50611b54565b60a26115588382612b41565b5060a36115658282612b41565b505050565b60008260000361159257811561158157600061158b565b670de0b6b3a76400005b905061079c565b610e976115a76115a185611c5e565b84611d14565b611d20565b60008080600019858709858702925082811083820303915050806000036115e557600084116115da57600080fd5b508290049050610e97565b8084116115f157600080fd5b60008486880960026001871981018816978890046003810283188082028403028082028403028082028403028082028403028082028403029081029092039091026000889003889004909101858311909403939093029303949094049190911702949350505050565b60006107cf607054606b546113e1565b80156117f257600061168e61168183606e54611a55565b6116896107a2565b611d4e565b90506000811361169d57600080fd5b60675460405163a9059cbb60e01b81526001600160a01b038581166004830152602482018590529091169063a9059cbb906044016020604051808303816000875af11580156116f0573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906117149190612c01565b61171d57600080fd5b6065546066546001600160a01b0390911690637cdd3fde908561173f85612c23565b6040516001600160e01b031960e086901b16815260048101939093526001600160a01b0390911660248301526044820152606401600060405180830381600087803b15801561178d57600080fd5b505af11580156117a1573d6000803e3d6000fd5b505050506117b1606a54826113e1565b606a556001600160a01b0383166000908152606d60205260409020546117d790826113e1565b6001600160a01b0384166000908152606d6020526040902055505b6001600160a01b0382166000908152606d60205260409020546069546118189190611d6b565b6001600160a01b0383166000908152606c602090815260409182902092909255518281527fb20101a10c7cc8d4a9b5accf3d34c34f89d53ec195fce51620af16429526c75591015b60405180910390a15050565b80156119e357600061189061188383606e54611a55565b61188b6107a2565b611266565b90506000811361189f57600080fd5b6067546040516323b872dd60e01b81526001600160a01b03858116600483015230602483015260448201859052909116906323b872dd906064016020604051808303816000875af11580156118f8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061191c9190612c01565b61192557600080fd5b606554606654604051633e6e9fef60e11b815260048101919091526001600160a01b0385811660248301526044820184905290911690637cdd3fde90606401600060405180830381600087803b15801561197e57600080fd5b505af1158015611992573d6000803e3d6000fd5b505050506119a2606a5482611450565b606a556001600160a01b0383166000908152606d60205260409020546119c89082611450565b6001600160a01b0384166000908152606d6020526040902055505b6001600160a01b0382166000908152606d6020526040902054606954611a099190611d6b565b6001600160a01b0383166000908152606c602090815260409182902092909255518281527f858d2e17a8121c939a8c52f6821c748d2592cc8ecd8e6afcda3fc4c84248002f9101611860565b6000811580611a7957508282611a6b81836129b6565b9250611a7790836129e3565b145b61079c5760405162461bcd60e51b815260206004820152601460248201527364732d6d6174682d6d756c2d6f766572666c6f7760601b6044820152606401610c97565b600080821215611b105768033dd1780914b9711419821215611ae057506000919050565b611aec82600003611abc565b6ec097ce7bc90715b34b9f100000000081611b0957611b096129cd565b0592915050565b680a688906bd8b0000008212611b3c5760405163e69458f960e01b815260048101839052602401610c97565b670de0b6b3a7640000604083901b04610e9781611d8c565b600054610100900460ff16611b7b5760405162461bcd60e51b8152600401610c9790612aa8565b611b83612488565b606580546001600160a01b038086166001600160a01b03199283161790925560668490556067805492841692909116821790556040805163313ce56760e01b815290516000929163313ce567916004808301926020929190829003018187875af1158015611bf5573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c199190612c3f565b60ff1690506012811115611c2c57600080fd5b6068819055611c3c8160126129a3565b611c4790600a612d40565b606e55611c5581600a612d40565b606f5550505050565b6000670de0b6b3a7640000821015611c8c57604051633621413760e21b815260048101839052602401610c97565b6000611ca1670de0b6b3a764000084046124b7565b670de0b6b3a764000081029250905082811c670de0b6b3a763ffff198101611cca575050919050565b6706f05b59d3b200005b8015611d0c57670de0b6b3a7640000828002049150671bc16d674ec800008210611d04579283019260019190911c905b60011c611cd4565b505050919050565b6000610e97838361259b565b6000680a688906bd8b0000008210611b3c57604051634a4f26f160e01b815260048101839052602401610c97565b6000610e97611d6584670de0b6b3a7640000611a55565b83612661565b6000610e97611d7a8484611a55565b6b033b2e3c9fd0803ce8000000612661565b600160bf1b678000000000000000821615611db05768016a09e667f3bcc9090260401c5b674000000000000000821615611dcf576801306fe0a31b7152df0260401c5b672000000000000000821615611dee576801172b83c7d517adce0260401c5b671000000000000000821615611e0d5768010b5586cf9890f62a0260401c5b670800000000000000821615611e2c576801059b0d31585743ae0260401c5b670400000000000000821615611e4b57680102c9a3e778060ee70260401c5b670200000000000000821615611e6a5768010163da9fb33356d80260401c5b670100000000000000821615611e8957680100b1afa5abcbed610260401c5b6680000000000000821615611ea75768010058c86da1c09ea20260401c5b6640000000000000821615611ec5576801002c605e2e8cec500260401c5b6620000000000000821615611ee357680100162f3904051fa10260401c5b6610000000000000821615611f01576801000b175effdc76ba0260401c5b6608000000000000821615611f1f57680100058ba01fb9f96d0260401c5b6604000000000000821615611f3d5768010002c5cc37da94920260401c5b6602000000000000821615611f5b576801000162e525ee05470260401c5b6601000000000000821615611f795768010000b17255775c040260401c5b65800000000000821615611f96576801000058b91b5bc9ae0260401c5b65400000000000821615611fb357680100002c5c89d5ec6d0260401c5b65200000000000821615611fd05768010000162e43f4f8310260401c5b65100000000000821615611fed57680100000b1721bcfc9a0260401c5b6508000000000082161561200a5768010000058b90cf1e6e0260401c5b65040000000000821615612027576801000002c5c863b73f0260401c5b6502000000000082161561204457680100000162e430e5a20260401c5b65010000000000821615612061576801000000b1721835510260401c5b64800000000082161561207d57680100000058b90c0b490260401c5b6440000000008216156120995768010000002c5c8601cc0260401c5b6420000000008216156120b5576801000000162e42fff00260401c5b6410000000008216156120d15768010000000b17217fbb0260401c5b6408000000008216156120ed576801000000058b90bfce0260401c5b64040000000082161561210957680100000002c5c85fe30260401c5b6402000000008216156121255768010000000162e42ff10260401c5b64010000000082161561214157680100000000b17217f80260401c5b638000000082161561215c5768010000000058b90bfc0260401c5b6340000000821615612177576801000000002c5c85fe0260401c5b632000000082161561219257680100000000162e42ff0260401c5b63100000008216156121ad576801000000000b17217f0260401c5b63080000008216156121c857680100000000058b90c00260401c5b63040000008216156121e35768010000000002c5c8600260401c5b63020000008216156121fe576801000000000162e4300260401c5b63010000008216156122195768010000000000b172180260401c5b62800000821615612233576801000000000058b90c0260401c5b6240000082161561224d57680100000000002c5c860260401c5b622000008216156122675768010000000000162e430260401c5b6210000082161561228157680100000000000b17210260401c5b6208000082161561229b5768010000000000058b910260401c5b620400008216156122b5576801000000000002c5c80260401c5b620200008216156122cf57680100000000000162e40260401c5b620100008216156122e9576801000000000000b1720260401c5b61800082161561230257680100000000000058b90260401c5b61400082161561231b5768010000000000002c5d0260401c5b612000821615612334576801000000000000162e0260401c5b61100082161561234d5768010000000000000b170260401c5b610800821615612366576801000000000000058c0260401c5b61040082161561237f57680100000000000002c60260401c5b61020082161561239857680100000000000001630260401c5b6101008216156123b157680100000000000000b10260401c5b60808216156123c957680100000000000000590260401c5b60408216156123e1576801000000000000002c0260401c5b60208216156123f957680100000000000000160260401c5b6010821615612411576801000000000000000b0260401c5b600882161561242957680100000000000000060260401c5b600482161561244157680100000000000000030260401c5b600282161561245957680100000000000000010260401c5b600182161561247157680100000000000000010260401c5b670de0b6b3a76400000260409190911c60bf031c90565b600054610100900460ff166124af5760405162461bcd60e51b8152600401610c9790612aa8565b6107e6612673565b6000600160801b82106124d757608091821c916124d49082612a95565b90505b6801000000000000000082106124fa57604091821c916124f79082612a95565b90505b640100000000821061251957602091821c916125169082612a95565b90505b62010000821061253657601091821c916125339082612a95565b90505b610100821061255257600891821c9161254f9082612a95565b90505b6010821061256d57600491821c9161256a9082612a95565b90505b6004821061258857600291821c916125859082612a95565b90505b6002821061060c57610609600182612a95565b60008080600019848609848602925082811083820303915050670de0b6b3a764000081106125df5760405163698d9a0160e11b815260048101829052602401610c97565b600080670de0b6b3a764000086880991506706f05b59d3b1ffff821190508260000361261d5780670de0b6b3a764000085040194505050505061079c565b620400008285030493909111909103600160ee1b02919091177faccb18165bd6fe31ae1cf318dc5b51eee0e1ba569b88cd74c1773b91fac106690201905092915050565b60008161127b84610ae58560016113e1565b600054610100900460ff1661269a5760405162461bcd60e51b8152600401610c9790612aa8565b6107e6336112df565b606480612d4d83390190565b61016c80612db183390190565b600060208083528351808285015260005b818110156126e9578581018301518582016040015282016126cd565b506000604082860101526040601f19601f8301168501019250505092915050565b80356001600160a01b038116811461060c57600080fd5b60006020828403121561273357600080fd5b610e978261270a565b60006020828403121561274e57600080fd5b5035919050565b6000806040838503121561276857600080fd5b6127718361270a565b946020939093013593505050565b60ff81168114610e4a57600080fd5b6000602082840312156127a057600080fd5b8135610e978161277f565b600080604083850312156127be57600080fd5b82356127718161277f565b634e487b7160e01b600052604160045260246000fd5b600082601f8301126127f057600080fd5b813567ffffffffffffffff8082111561280b5761280b6127c9565b604051601f8301601f19908116603f01168101908282118183101715612833576128336127c9565b8160405283815286602085880101111561284c57600080fd5b836020870160208301376000602085830101528094505050505092915050565b600080600080600080600060e0888a03121561288757600080fd5b6128908861270a565b965061289e6020890161270a565b95506128ac6040890161270a565b94506128ba6060890161270a565b9350608088013567ffffffffffffffff808211156128d757600080fd5b6128e38b838c016127df565b945060a08a01359150808211156128f957600080fd5b506129068a828b016127df565b92505060c08801356129178161277f565b8091505092959891949750929550565b60008060006060848603121561293c57600080fd5b505081359360208301359350604090920135919050565b600181811c9082168061296757607f821691505b60208210810361298757634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b8181038181111561079c5761079c61298d565b808202811582820484141761079c5761079c61298d565b634e487b7160e01b600052601260045260246000fd5b6000826129f2576129f26129cd565b500490565b600060208284031215612a0957600080fd5b5051919050565b8181036000831280158383131683831282161715612a3057612a3061298d565b5092915050565b600082612a4657612a466129cd565b600160ff1b821460001984141615612a6057612a6061298d565b500590565b80820260008212600160ff1b84141615612a8157612a8161298d565b818105831482151761079c5761079c61298d565b8082018082111561079c5761079c61298d565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b601f82111561156557600081815260208120601f850160051c81016020861015612b1a5750805b601f850160051c820191505b81811015612b3957828155600101612b26565b505050505050565b815167ffffffffffffffff811115612b5b57612b5b6127c9565b612b6f81612b698454612953565b84612af3565b602080601f831160018114612ba45760008415612b8c5750858301515b600019600386901b1c1916600185901b178555612b39565b600085815260208120601f198616915b82811015612bd357888601518255948401946001909101908401612bb4565b5085821015612bf15787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b600060208284031215612c1357600080fd5b81518015158114610e9757600080fd5b6000600160ff1b8201612c3857612c3861298d565b5060000390565b600060208284031215612c5157600080fd5b8151610e978161277f565b600181815b80851115612c97578160001904821115612c7d57612c7d61298d565b80851615612c8a57918102915b93841c9390800290612c61565b509250929050565b600082612cae5750600161079c565b81612cbb5750600061079c565b8160018114612cd15760028114612cdb57612cf7565b600191505061079c565b60ff841115612cec57612cec61298d565b50506001821b61079c565b5060208310610133831016604e8410600b8410161715612d1a575081810a61079c565b612d248383612c5c565b8060001904821115612d3857612d3861298d565b029392505050565b6000610e978383612c9f56fe6080604052348015600f57600080fd5b50604780601d6000396000f3fe6080604052348015600f57600080fd5b00fea2646970667358221220818d3cb11b4ab2472d05dcde706f043eadf2e46d4744361f00ec3b1e2c2c699d64736f6c63430008110033608060405234801561001057600080fd5b5061014c806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c806323b872dd14610043578063313ce5671461006f578063a9059cbb1461007e575b005b61005a6100513660046100b0565b60019392505050565b60405190151581526020015b60405180910390f35b60405160128152602001610066565b61005a61008c3660046100ec565b600192915050565b80356001600160a01b03811681146100ab57600080fd5b919050565b6000806000606084860312156100c557600080fd5b6100ce84610094565b92506100dc60208501610094565b9150604084013590509250925092565b600080604083850312156100ff57600080fd5b61010883610094565b94602093909301359350505056fea2646970667358221220883cb65249cae5b139a495e0ed42d05a5207212b61bc54efaf34a779beace7b464736f6c63430008110033a2646970667358221220ffafd294302d73a0afd4738b92d8690c2dd792a7fe11b0256009995d80f77ec264736f6c63430008110033";

type VestaEIRConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VestaEIRConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VestaEIR__factory extends ContractFactory {
  constructor(...args: VestaEIRConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<VestaEIR> {
    return super.deploy(overrides || {}) as Promise<VestaEIR>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VestaEIR {
    return super.attach(address) as VestaEIR;
  }
  override connect(signer: Signer): VestaEIR__factory {
    return super.connect(signer) as VestaEIR__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VestaEIRInterface {
    return new utils.Interface(_abi) as VestaEIRInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VestaEIR {
    return new Contract(address, _abi, signerOrProvider) as VestaEIR;
  }
}
